<mat-card>
    <mat-card-title>{{getLabel('label.reset.password')}}</mat-card-title>
    <mat-card-content>
        <form [formGroup]="form" class="mxs-form" (keydown.enter)="$event.stopPropagation();">
            <mat-form-field class="mxs-input">
                <mat-label>{{getLabel('label.contact.us.name')}}</mat-label>
                <input type="text" matInput formControlName="username">
                <mat-error *ngIf="form.get('username')?.hasError('required')">
                    {{getLabel('label.errors.mandatory')}}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="mxs-input">
                <mat-label>{{getLabel('label.contact.us.email')}}</mat-label>
                <input type="email" matInput formControlName="email">
                <mat-error *ngIf="form.get('email')?.hasError('required')">
                    {{getLabel('label.errors.mandatory')}}
                </mat-error>
                <mat-error *ngIf="form.get('email')?.hasError('email')">
                    {{getLabel('label.errors.mandatory')}}
                </mat-error>
            </mat-form-field>

            <div *ngIf="error" class="error">
                {{ error }}
            </div>

            <div class="button">
                <mx-button [buttonModel]="submitButton"></mx-button>

                <mx-button [buttonModel]="cancelButton"></mx-button>
            </div>
        </form>
    </mat-card-content>
</mat-card>
